var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.$wait.waiting(_vm._uid)),expression:"$wait.waiting(_uid)"}]},[_c('print-record',{attrs:{"user":_vm.user,"records":_vm.topics}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }